import { ArrowDownIcon } from '@heroicons/react/24/outline'

import { anim, prog, stagger } from '../../../motion'
import { Count } from '../../../primitives'
import { Line, Words } from '../../../v2/kit'
import { useCopy } from '../../i18n'
import { Badges, Marquee } from '../../kit'
import { LOGOS } from '../copy'

const MARQUEE = [
  ['Lufthansa', LOGOS.lufthansa],
  ['Beiersdorf', LOGOS.beiersdorf],
  ['OMR', LOGOS.omr],
  ['Frankfurt School', LOGOS.frankfurtSchool],
  ['Callways', LOGOS.callways],
  ['MCI', LOGOS.mci],
  ['persona service', LOGOS.personaService]
]

// Das Versprechen schreibt sich ins Bild, rückt nach oben und gibt die drei Zahlen frei
export default function DemoIntro() {
  const c = useCopy('intro')
  const ui = useCopy('ui')

  return (
    <div className='cin-full'>
      <div className='dm-intro' style={prog([0.3, 0.44])}>
        <Line
          at={[-1, 0]}
          out={[0.28, 0.34]}
          y={20}
          className='cin-eyebrow cin-eyebrow--light'
        >
          {c.eyebrow}
        </Line>
        <h1 className='dm-hero-title'>
          <span className='dm-mark' style={prog([0.08, 0.16])}>
            <Words text={c.lead} at={[0, 0.08]} dim={0.22} />
          </span>{' '}
          <Words text={c.title} at={[0.06, 0.24]} dim={0.22} />
        </h1>
      </div>

      <div className='dm-stats'>
        {c.stats.map((s, i) => (
          <div
            key={s.label}
            className='dm-stat'
            style={anim({ at: stagger(0.4, 0.06, 0.1, i), y: 80 })}
          >
            <Count
              to={s.to}
              at={stagger(0.42, 0.06, 0.16, i)}
              suffix={s.suffix}
              className='dm-stat__num'
            />
            <div className='dm-stat__label'>{s.label}</div>
          </div>
        ))}
      </div>

      <div className='dm-trust' style={anim({ at: [0.66, 0.78], y: 60 })}>
        <Badges items={c.badges} light />
        <div className='dm-trust__text'>{c.trust}</div>
        <Marquee logos={MARQUEE} />
        <div className='dm-sources'>{c.sources}</div>
      </div>

      <div
        className='cin-cue'
        style={anim({ at: [-1, 0], out: [0.02, 0.08], oy: 20 })}
      >
        <ArrowDownIcon width={18} height={18} />
        {ui.cue}
      </div>
    </div>
  )
}
